const config = (url) => ({
    height: 500,
    menubar: false,
    images_upload_url: url,
    setup: function () {
        window.tinymce.PluginManager.add('CTA_Maker', function (editor) {
            // Add a button that opens a window
            editor.ui.registry.addButton('CTA_Maker', {
                text: 'درج گزینه آزمون',
                icon: '',
                onAction: function () {
                    editor.windowManager.open({
                        title: '',
                        body: {
                            type: 'panel',
                            items: [
                                { type: 'input', name: 'number', label: 'Question Number' },
                                { type: 'input', name: 'wrapper', label: 'Questions Set (For Example:1-3 or 8-11)' },
                                {
                                    type: 'selectbox',
                                    name: 'type',
                                    label: 'options',
                                    items: [
                                        { text: 'Input Text', value: 'text' },
                                        { text: 'Check Box', value: 'checkbox' },
                                        { text: 'Radio Button', value: 'radio' },
                                        { text: 'DropDown', value: 'select' },
                                    ],
                                    flex: true
                                },
                                { type: 'input', name: 'answer', label: 'Correct Answer' },
                                { type: 'input', name: 'options', label: 'Options(camma separated)' },
                            ]
                        },
                        onSubmit: function (api) {

                            const { type, number, options, answer, wrapper } = api.getData();

                            let output = "";
                            switch (type) {
                                case "text":
                                    output = `<input data-wrapper="${wrapper}" data-answer="${answer}" type="text" id="q${number}" class="underscore_input" data-number="${number}">`
                                    break;
                                case "checkbox":
                                    output = `<input data-wrapper="${wrapper}" data-answer="${answer.toUpperCase()}" type="checkbox" name="q${number}" value="${options.toUpperCase()}" class="underscore_input" data-number="${number}">`
                                    break;
                                case "radio":
                                    output = `<input data-wrapper="${wrapper}" data-answer="${answer.toUpperCase()}" type="radio" name="q${number}" value="${options.toUpperCase()}" class="underscore_input" data-number="${number}">`
                                    break;
                                case "select":

                                    output = `<select data-wrapper="${wrapper}" data-answer="${answer.toUpperCase()}" id="q${number}" value="${options}" class="underscore_input" data-number="${number}">`;
                                    output += `<option value=""></option>`;

                                    options.split(',').forEach(opt => {
                                        output += `<option value="${opt.toUpperCase()}">${opt.toUpperCase()}</option>`;
                                    });

                                    output += `</select>`;

                                    break;
                                default:
                                    break;
                            }
                            // insert markup
                            editor.insertContent(output);
                            // close the dialog
                            api.close();
                        },
                        buttons: [
                            {
                                text: 'Close',
                                type: 'cancel',
                                onclick: 'close'
                            },
                            {
                                text: 'Insert',
                                type: 'submit',
                                primary: true,
                                enabled: false
                            }
                        ]
                    });

                }
            });
        });
    },
    plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount directionality CTA_Maker',
    ],
    toolbar:
        'undo redo | code | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | ltr rtl | \
             fontsizeselect | link image | print preview media | CTA_Maker',
})

export default config;

